import React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { StyledFormContainer } from '../../../../styled';

import { AddressSection } from './components';

export const FormSkeleton: ReactFCV<IBasicStyledProps> = ({ ...rest }) => (
  <StyledFormContainer data-testid="form-skeleton" {...rest}>
    <AddressSection data-testid="styled-address-section" />
  </StyledFormContainer>
);
